<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="!everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>system_update_alt</md-icon>
          </div>
          <h4 class="title">Import overzicht</h4>
        </md-card-header>
        <md-card-content>
          <md-checkbox v-model="includeProcessed"
            >Toon verwerkte imports</md-checkbox
          >

          <md-table
            v-if="everythingLoaded"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Imports per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek import(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Naam"
                md-sort-by="name"
              >
                {{ getTemplateName(item.template_id) }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Status"
                md-sort-by="status"
              >
                {{ getStatusName(item.status) }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Laatste wijziging"
                md-sort-by="date"
              >
                {{ formatDate(item.updated_at) }}
              </md-table-cell>
              <md-table-cell md-label="Verwijderen">
                <div class="md-group">
                  <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="handleDelete(item)"
                  >
                    <md-icon>delete</md-icon>
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions v-if="everythingLoaded" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van {{ total }} imports
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>

      <md-button
        :disabled="!everythingLoaded"
        native-type="button"
        @click.native.prevent="handleTemplates"
        class="md-primary"
        >Import Templates Beheren</md-button
      >

      <md-button
        :disabled="!everythingLoaded"
        native-type="button"
        @click.native.prevent="handleAdd"
        class="md-success"
        >Import toevoegen</md-button
      >
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableDataFiltered;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDataFiltered.length;
    },
    nextYear() {
      return new Date().getFullYear() + 1;
    },
    tableDataFiltered: function() {
      var data = [];
      for (var i in this.tableData) {
        if (this.includeProcessed === false && this.tableData[i].status === 3) {
          continue;
        }

        data.push(this.tableData[i]);
      }

      return data;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  data() {
    return {
      currentSort: "date",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["name", "date"],
      tableData: [],
      importTemplates: [],
      searchedData: [],
      fuseSearch: null,
      includeProcessed: false,
      timestampNow: Math.floor(Date.now() / 1000),
      loaded: {
        imports: false,
        templates: false
      }
    };
  },
  methods: {
    getStatusName: function(status) {
      if (status === 1) {
        return "Gegevens ge-upload";
      } else if (status === 2) {
        return "Gegevens geanalyseerd";
      } else if (status === 3) {
        return "Gegevens verwerkt";
      }

      return "Nieuw";
    },
    getTemplateName: function(templateId) {
      for (let i in this.importTemplates) {
        if (this.importTemplates[i].id === templateId) {
          return this.importTemplates[i].name;
        }
      }

      return "Onbekend!";
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("-") + " " + date.split(" ")[1];
    },
    loadImports() {
      this.loaded.imports = false;
      this.$http.get(this.$apiBaseUrl + "import").then(
        response => {
          this.tableData = response.data.imports;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "date"],
            threshold: 0.3
          });

          this.loaded.imports = true;
        },
        response => {
          if (response.status === 403) {
            this.generateDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van imports",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadImportTemplates() {
      this.loaded.templates = false;
      this.$http.get(this.$apiBaseUrl + "import/templates").then(
        response => {
          this.importTemplates = response.data.importTemplates;

          this.loaded.templates = true;
        },
        response => {
          if (response.status === 403) {
            this.generateDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van imports",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    handleEdit(item) {
      this.$router.push("/drivers/imports/edit/" + item.id);
    },
    handleAdd() {
      this.$router.push("/drivers/imports/add");
    },
    handleTemplates() {
      this.$router.push("/drivers/imports/templates/overview");
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Import "${item.name}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.delete(this.$apiBaseUrl + "import/" + item.id).then(
            response => {
              this.deleteRow(item);

              this.notifyVue(
                "Import succesvol verwijderd",
                "check",
                "success",
                5000
              );

              // Fuse search initialization.
              this.fuseSearch = new Fuse(this.tableData, {
                keys: ["name", "date"],
                threshold: 0.3
              });
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het beheren van Imports",
                  "add_alert",
                  "danger",
                  0
                );
              }
            }
          );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    getTimestampForDate(date) {
      return Math.floor(new Date(date + "T23:59:59.999+0200").getTime() / 1000);
    }
  },
  mounted() {
    this.loadImportTemplates();
    this.loadImports();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
.md-card .md-table-cell.cursor-mail {
  cursor: url("/img/default/pointers/mail.svg"), auto;
}
</style>
